import { FAILED_TO_PUBLISH, MESSAGE_TYPE_ID } from '../constants/messageTypes';
export function buildFailedToPublishObject(props = {}) {
  return Object.assign({
    [MESSAGE_TYPE_ID]: FAILED_TO_PUBLISH,
    id: null,
    threadId: null,
    channel: null,
    channelName: '',
    genericChannelId: null,
    message: null,
    allowRetry: true,
    timestamp: null
  }, props);
}